import React, { useState } from "react";
import { ChevronDown, FileText } from "lucide-react";

const announcements = [
  {
    companyId: "montana-energy-rom",
    companyName: "Montana Energy Rom",
    date: "10/09/2026",
    title: "ANUNT DE PARTICIPARE PROCEDURA COMPETITIVA - LICITATIE NR.1",
    subtitle: "Instalare capacitate de stocare a energiei electrice pentru CEF Stanesti",
    files: [
      { name: "1. Nota estimativa CEF Stanesti MER", file: "/mer-1-nota-estimativa.pdf" },
      { name: "2. Caiet de sarcini MER Stanesti lot 1 - Furnizare rev. 08.09", file: "/mer-2-caiet-sarcini-lot1-furnizare.pdf" },
      { name: "3. Caiet de sarcini MER Stanesti lot 2 - EPC", file: "/mer-3-caiet-sarcini-lot2-epc.pdf" },
      { name: "4. Studiu de Fezabilitate BESS Stanesti - Atasament 2", file: "/mer-4-studiu-fezabilitate-bess.pdf" },
      { name: "5. Model contract MER - lot 1 Furnizare", file: "/mer-5-model-contract-lot1-furnizare.pdf" },
      { name: "6. Model contract MER - lot 2 EPC", file: "/mer-6-model-contract-lot2-epc.pdf" },
      { name: "7. Anunt de participare - CEF Stanesti MER", file: "/mer-7-anunt-participare.pdf" },
      { name: "8. ATR MER nr 29038410 din 16.01.2026 PV si BESS", file: "/mer-8-atr-29038410.pdf" },
      { name: "9. Erata nr. 1 MER Stanesti", file: "/mer-9-erata-nr1-stanesti.pdf" },
      { name: "10. Raspuns Clarificari Lot 1 Montana Energy Rom", file: "/mer-10-raspuns-clarificari-lot1.pdf" },
      { name: "11. Erata nr.2 MER Stanesti", file: "/mer-11-erata-nr2-stanesti.pdf" },
      { name: "12. Decizie Anulare Procedura CEF Stanesti", file: "/mer-12-decizie-anulare-procedura-stanesti.pdf" },
      { name: "13. Raport Anulare Procedura CEF Stanesti", file: "/mer-13-raport-anulare-procedura-stanesti.pdf" },
    ],
  },
  {
    companyId: "montana-energy-rom",
    companyName: "Montana Energy Rom",
    date: "28/10/2026",
    title: "ANUNT DE PARTICIPARE PROCEDURA COMPETITIVA - LICITATIE NR.2",
    subtitle: "Instalare capacitate de stocare a energiei electrice pentru CEF Stanesti",
    files: [
      { name: "1. Anunt de Participare CEF Stanesti MER - 27.10.2026", file: "/mer-1-anunt-de-participare-CEF-Stanesti.pdf" },
      { name: "2. Caiet de Sarcini MER Stanesti Lot 1 Furnizare - 27.10.2026", file: "/mer-2-caiet-dsarcini-Stanesti-lot1-furnizare.pdf" },
      { name: "3. Caiet de Sarcini MER Stanesti Lot 2 EPC - 27.10.2026", file: "/mer-3-caiet-de-sarcini-Stanesti-lot2-EPC.pdf" },
      { name: "4. Model Contract MER Lot 1 Furnizare - 27.10.2026", file: "/mer-4-model-contract-MER-lot1-furnizare.pdf" },
      { name: "5. Model Contract MER Lot 2 EPC - 27.10.2026", file: "/mer-5-model-contract-MER-lot2-EPC.pdf" },
      { name: "6. ATR MER nr.29038410 - 16.01.2026", file: "/mer-6-ATR-MER-nr29038410.pdf" },
      { name: "7. SF BESS Stanesti", file: "/mer-7-SF-BESS-Stanesti.pdf" },
    ],
  },
  {
    companyId: "montana-solar-energy",
    companyName: "Montana Solar Energy",
    date: "10/09/2026",
    title: "ANUNT DE PARTICIPARE PROCEDURA COMPETITIVA - LICITATIE NR.1",
    subtitle: "Instalare capacitate de stocare a energiei electrice pentru CEF Maxineni",
    files: [
      { name: "1. Nota estimativa CEF Maxineni", file: "/mse-1-nota-estimativa.pdf" },
      { name: "2. Caiet de sarcini MSE Maxineni lot 1 - Furnizare rev. 08.09", file: "/mse-2-caiet-sarcini-lot1-furnizare.pdf" },
      { name: "3. Caiet de sarcini MSE Maxineni lot 2 - EPC rev. 08.09", file: "/mse-3-caiet-sarcini-lot2-epc.pdf" },
      { name: "4. Model contract MSE - lot 1 Furnizare rev. 02.09", file: "/mse-4-model-contract-lot1-furnizare.pdf" },
      { name: "5. Model contract MSE - lot 2 EPC rev. 02.09", file: "/mse-5-model-contract-lot2-epc.pdf" },
      { name: "6. Anunt de participare - CEF Maxineni", file: "/mse-6-anunt-participare.pdf" },
      { name: "7. SF Montana Solar Energy rev 02.12 cu anexe - Atasament 7", file: "/mse-7-sf-montana-solar.pdf" },
      { name: "8. ATR actualizat PV si BESS MSE", file: "/mse-8-atr-actualizat.pdf" },
      { name: "9. Erata nr. 1 MSE Maxineni", file: "/mse-9-erata-nr1-maxineni.pdf" },
      { name: "10. Raspuns Clarificari Lot 1 Montana Solar Energy", file: "/mse-10-raspuns-clarificari-lot1.pdf" },
      { name: "11. Erata nr.2 MSE Maxineni", file: "/mse-11-erata-nr2-maxineni.pdf" },
      { name: "12. Decizie Anulare Procedura CEF Maxineni", file: "/mse-12-decizie-anulare-procedura-maxineni.pdf" },
      { name: "13. Raport Anulare Procedura CEF Maxineni", file: "/mse-13-raport-anulare-procedura-maxineni.pdf" },
    ],
  },
  {
    companyId: "montana-solar-energy",
    companyName: "Montana Solar Energy",
    date: "28/10/2026",
    title: "ANUNT DE PARTICIPARE PROCEDURA COMPETITIVA - LICITATIE NR.2",
    subtitle: "Instalare capacitate de stocare a energiei electrice pentru CEF Maxineni",
    files: [
      { name: "1. Anunt de Participare CEF Maxineni - 27.10.2026", file: "/mse-1-anunt-de-participare-Maxineni.pdf" },
      { name: "2. Caiet de Sarcini MSE Maxineni Lot 1 Furnizare - 27.10.2026", file: "/mse-2-caiet-de-sarcini-MSE-Maxineni-lot1.pdf" },
      { name: "3. Caiet de Sarcini MSE Maxineni Lot 2 EPC - 27.10.2026", file: "/mse-3-caiet-de-sarcini-MSE-Maxineni-lot2.pdf" },
      { name: "4. Model Contract MSE Lot 1 Furnizare - 27.10.2026", file: "/mse-4-model-contract-MSE-lot1-furnizare.pdf" },
      { name: "5. Model Contract MSE Lot 2 EPC - 27.10.2026", file: "/mse-5-model-contract-MSE-lot2-EPC.pdf" },
      { name: "6. ATRActualizat PV and BESS MSE", file: "/mse-6-ATR-actualizat-PV-and- BESS-MSE.pdf" },
      { name: "7. SF BESS MSE Maxineni", file: "/mse-7-SF-BESS-MSe-Maxineni.pdf" },
    ],
  },
];

async function downloadWithName(url, displayName) {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = displayName + ".pdf";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    window.open(url, "_blank");
  }
}

function AnnouncementCard({ announcement }) {
  const [open, setOpen] = useState(false);

  return (
    <div className="border border-[#E2E0D8] rounded-2xl overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full text-left px-6 md:px-10 py-7 md:py-9 flex items-start justify-between gap-6 hover:bg-[#F0EEE8] transition-colors duration-200"
      >
        <div className="flex-1">
          <p className="text-[#4A4F6B] text-[13px] uppercase tracking-[0.25em] font-semibold mb-3">
            {announcement.title}
          </p>
          <h3 className="font-serif text-[#00025C] text-lg md:text-xl lg:text-2xl font-medium tracking-tight leading-snug">
            {announcement.subtitle}
          </h3>
        </div>
        <div className="flex flex-col items-end gap-3 flex-shrink-0">
          <span className="text-[#4A4F6B]/60 text-xs tracking-wide whitespace-nowrap">
            {announcement.date}
          </span>
          <ChevronDown
            size={20}
            strokeWidth={1.5}
            className={`text-[#00025C]/60 transition-transform duration-300 ${open ? "rotate-180" : ""}`}
          />
        </div>
      </button>

      {open && (
        <div className="border-t border-[#E2E0D8] px-6 md:px-10 py-6 md:py-8 bg-white">
          <p className="text-[#4A4F6B] text-[10px] uppercase tracking-[0.25em] font-semibold mb-5">
            Documente disponibile
          </p>
          <ul className="space-y-2">
            {announcement.files.map((f, i) => (
              <li key={i}>
                <button
                  onClick={() => downloadWithName(f.file, f.name)}
                  className="group w-full flex items-center gap-4 p-4 rounded-xl border border-[#E2E0D8] hover:border-[#00025C]/30 hover:bg-[#F9F8F6] transition-all duration-200 text-left"
                >
                  <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center rounded-lg bg-[#00025C]/6 group-hover:bg-[#00025C] transition-colors duration-200">
                    <FileText
                      size={14}
                      strokeWidth={1.75}
                      className="text-[#00025C] group-hover:text-white transition-colors duration-200"
                    />
                  </div>
                  <span className="text-[#1A1D1A]/85 text-sm leading-snug group-hover:text-[#00025C] transition-colors duration-200 flex-1">
                    {f.name}
                  </span>
                  <span className="text-[#4A4F6B]/50 text-[10px] uppercase tracking-wider flex-shrink-0">
                    PDF
                  </span>
                </button>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

const companies = [
  { id: "montana-energy-rom", name: "Montana Energy Rom" },
  { id: "montana-solar-energy", name: "Montana Solar Energy" },
];

export default function Announcements() {
  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <section className="pt-32 pb-10 md:pt-40 md:pb-14 px-6 md:px-12 border-b border-[#E2E0D8]">
        <div className="mx-auto max-w-[1400px]">
          <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6 md:gap-8">
            <div>
              <h1 className="font-serif text-[#00025C] text-4xl md:text-5xl lg:text-[64px] leading-[1.05] tracking-tight font-semibold mb-4">
                Announcements
              </h1>
              <p className="text-[#4A4F6B]/75 text-sm font-normal leading-relaxed">
                Projects financed through the Modernization Fund
              </p>
              <p className="text-[#4A4F6B]/75 text-sm font-normal leading-relaxed">
                Proiecte finanțate prin Fondul pentru Modernizare
              </p>
            </div>
            <img
              src="/subsidiary-montana.png"
              alt="Montana Energy"
              className="h-9 md:h-11 w-auto object-contain opacity-80 self-start md:self-auto flex-shrink-0"
              draggable={false}
            />
          </div>
        </div>
      </section>

      <section className="py-20 md:py-28 px-6 md:px-12">
        <div className="mx-auto max-w-[1400px] space-y-20 md:space-y-28">
          {companies.map((company, i) => {
            const companyAnnouncements = announcements.filter(
              (a) => a.companyId === company.id
            );
            return (
              <div key={company.id} id={company.id}>
                <div className="flex items-center gap-4 mb-10 md:mb-14 border-b border-[#E2E0D8] pb-8">
                  <span className="font-serif text-[#00025C]/30 text-5xl md:text-6xl font-semibold tabular-nums leading-none">
                    {String(i + 1).padStart(2, "0")}
                  </span>
                  <h2 className="font-serif text-[#00025C] text-2xl md:text-3xl lg:text-4xl font-semibold tracking-tight">
                    {company.name}
                  </h2>
                </div>

                <div className="space-y-4">
                  {companyAnnouncements.map((announcement, j) => (
                    <AnnouncementCard key={j} announcement={announcement} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
    </div>
  );
}
